export const permissions = {
  disabled: 'No access',
  read: 'Read only',
  write: 'Read and write',
};

export const onSelectPermissionOptions = Object.keys(permissions).map((i) => ({
  value: i,
  label: permissions[i],
}));

export const userPermissions = {
  disabled: 'disabled',
  read: 'read',
  write: 'write',
};
